import { ListItemButton } from '@mui/material';
import { styled } from '@mui/material/styles';

export type ListItemPropsType = {
  className?: string;
  disabled?: boolean;
  children: JSX.Element | JSX.Element[];
  onClick?: () => void;
  selectedItem?: boolean;
};

const StyledListItem = styled(ListItemButton)(({ theme }) => ({
  borderTop: '1px solid',
  borderColor: theme.palette.secondary.lowContrast,
  paddingTop: theme.spacing(2.5),
  paddingBottom: theme.spacing(2.5),
  '&:hover': {
    backgroundColor: theme.palette.primary.lightest,
    cursor: 'pointer',
  },
}));

export function ListItem(props: ListItemPropsType): JSX.Element {
  const { children, onClick, selectedItem } = props;

  return (
    <StyledListItem selected={selectedItem} onClick={onClick}>
      {children}
    </StyledListItem>
  );
}
